import * as React from "react";

const WhyManufacture = () => {
    return (
        <div>
            <p className="text-center mb-0 pb-0" data-sal="slide-down" data-sal-delay="300" data-sal-duration="400">
                <h2 className="bb-primary mb-0 pb-2 d-inline-block ">Dlaczego Manufaktura Zdrowych Stóp?</h2>
            </p>

            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5">
                <div className="col d-flex align-items-start" data-sal="slide-right" data-sal-delay="200">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Gabinet podologiczny</h5>
                        <p>Profesjonalny gabinet wyposażony w nowoczesny sprzet specjalistyczny.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-down" data-sal-delay="400">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Bezpieczeństwo zabiegów</h5>
                        <p>Czystość i sterylność zapewniona przez nowoczesny sprzęt klasy medycznej.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-down" data-sal-delay="200">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Doświadczony specjalista</h5>
                        <p>Ponad 12 lat doświadczenia zawodowego w pracy z pacjentem.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-right" data-sal-delay="250">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Podolog Kielce południe</h5>
                        <p>Szybki dojazd z południowej części miasta: Kielce Barwinek, Kielce Baranówek. Uniknij stania w korkach w centrum miasta. Darmowy parking dla klientów.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-right" data-sal-delay="300">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Gabinet refleksologii</h5>
                        <p>Gabinet zaprojektowany z myślą o komforcie pacjenta.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-up" data-sal-delay="200">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Ciągłe doskonalenie</h5>
                        <p>Stale podnosimy swoje umiejętności poprzez uczestnictwo w szkoleniach oraz kursach.</p>
                    </div>
                </div>
                <div className="col d-flex align-items-start" data-sal="slide-up" data-sal-delay="300">
                    <svg className="bi text-muted flex-shrink-0 me-3" width="1.75em" height="1.75em">
                    </svg>
                    <div>
                        <h5 className="fw-bold mb-0 pb-2">Miła atmosfera</h5>
                        <p>Wizyta w gabinecie to nie tylko zabieg, ale także chwila relaksu dla ciała i umysłu.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyManufacture